module.exports = __webpack_public_path__ + "img/01.0d9e08a8.png";